import React from "react";
import "./Payment.css";
import { Switch, Route } from "react-router-dom";
import PaymentOptions from "./PaymentOptions";
import PaymentMethod from "./PaymentMethod";
import PaymentPaypal from "./PaymentPaypal";
import PaymentStripe from "./PaymentStripe";
import PaymentThankYou from "./PaymentThankYou";
import PaymentFailed from "./PaymentFailed";
import PaymentBankMethod from "./PaymetBankMethod";
import PaymentLoading from "./PaymentLoading";
import BankSelect from "./BankSelect";
import BankPaying from "./BankPaying";
import BankAuth from "./BankAuth";
import BankOtp from "./BankOtp";
import BankAccountType from "./BankAccountType";
import ConfirmPayment from "./ConfirmPayment";
import PaymentSuccess from "./PaymentSuccess";
import BankAuthQr from "./BankAuthQr";
const PaymentForm = ({ data }) => {
  return (
    <>
      <div className="home_form_div_md">
        <div className="payment_wrapper">
          <Switch>
            <Route
              exact
              path="/payment/method"
              render={(_) => <PaymentMethod data={data} />}
            />
            <Route
              exact
              path="/payment/options"
              render={(_) => <PaymentOptions data={data} />}
            />
            <Route
              exact
              path="/payment/paypal"
              render={(_) => <PaymentPaypal data={data} />}
            />
            <Route
              exact
              path="/payment/stripe"
              render={(_) => <PaymentStripe data={data} />}
            />
            <Route
              exact
              path="/payment/thank-you"
              render={(_) => <PaymentThankYou data={data} />}
            />
            <Route
              exact
              path="/payment/failed"
              render={(_) => <PaymentFailed data={data} />}
            />
            <Route
              exact
              path="/payment/bank-method"
              render={(_) => <PaymentBankMethod data={data} />}
            />
            <Route
              exact
              path="/payment/loading"
              render={(_) => <PaymentLoading data={data} />}
            />
            <Route
              exact
              path="/payment/select-bank"
              render={(_) => <BankSelect data={data} />}
            />
            <Route
              exact
              path="/payment/paying-bank"
              render={(_) => <BankPaying data={data} />}
            />
            <Route
              exact
              path="/payment/bank-auth"
              render={(_) => <BankAuth data={data} />}
            />
            <Route
              exact
              path="/payment/bank-qrcode"
              render={(_) => <BankAuthQr data={data} />}
            />
            <Route
              exact
              path="/payment/bank-otp"
              render={(_) => <BankOtp data={data} />}
            />
            <Route
              exact
              path="/payment/bank-type"
              render={(_) => <BankAccountType data={data} />}
            />
            <Route
              exact
              path="/payment/confirm-payment"
              render={(_) => <ConfirmPayment data={data} />}
            />
            <Route
              exact
              path="/payment/success"
              render={(_) => <PaymentSuccess data={data} />}
            />
          </Switch>
        </div>
      </div>
    </>
  );
};

export default PaymentForm;
